import { getTranslateByKey } from "@/main/services/utils";
import SecondaryButton from "@/main/components/shared/button/secondaryButton";
import WarningIcon from "@mui/icons-material/Warning";

// Components/Styles Local
import * as S from "./styles";

interface IModalNationalRequote {
	handleClose: () => void;
	titleModal: string;
}

function ModalNationalRequote({ titleModal, handleClose }: IModalNationalRequote) {
	function handleSetClose() {
		handleClose();
	}

	return (
		<S.BoxModal>
			<S.ContainerTextModal>
				<WarningIcon style={{ color: "#fab01c" }} fontSize="large" />
				<S.TitleModal>{titleModal}</S.TitleModal>
			</S.ContainerTextModal>
			<div
				style={{
					display: "flex",
					justifyContent: "center",
				}}
			>
				<SecondaryButton type="button" onClick={handleSetClose}>
					{getTranslateByKey("information.close")}
				</SecondaryButton>
			</div>
		</S.BoxModal>
	);
}

export default ModalNationalRequote;
